/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationreasonspam2Inputs */

const en_moderationreasonspam2 = /** @type {(inputs: Moderationreasonspam2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spam`)
};

const de_moderationreasonspam2 = /** @type {(inputs: Moderationreasonspam2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spam`)
};

/**
* | output |
* | --- |
* | "Spam" |
*
* @param {Moderationreasonspam2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationreasonspam2 = /** @type {((inputs?: Moderationreasonspam2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationreasonspam2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationreasonspam2(inputs)
	return de_moderationreasonspam2(inputs)
});
export { moderationreasonspam2 as "moderationReasonSpam" }